module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-01.0cb9fd1a.svg";